import { ITimeInterval } from "@/types/clsTypes";

export const defaultTimeintervals: ITimeInterval = {
	id: "default",
	name: "default",
	days: "all",
	weekdays: [1, 2, 3, 4, 5, 6, 7],
	months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
	dates: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
	intervals: [[0, 1440]],
};
